import { Component, OnInit } from '@angular/core';
import { FrontOffService, Dropobj,HrmsService,MasterService,AuthService } from '../../services/index';

import { HttpClient } from '@angular/common/http';
import {Router,ActivatedRoute,Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router'
import {WebcamImage} from 'ngx-webcam';
import {Subject, Observable} from 'rxjs';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { registerLocaleData } from '@angular/common';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  providers:[FrontOffService,HrmsService,MasterService,AuthService],
})
export class UsersComponent implements OnInit {

  arremp:any=[];
  arrdept:any=[];
  arrdept1:any=[];
  arrrolesall:any=[];
  defdep:any;
  arrdesig:any=[];
  arrdesig1:any=[];
  defdes:any;
  emparr:any=[];
  emparr1:any=[];
  statuses:any=[{value:'Active',name:'Active'},{value:'Inactive',name:'Inactive'}];
  arrstatus=[{name:'Active'},{name:'Inactive'}];
  defstat='Active';
  arrcourse:any=[];
  arrcourse1:any=[];

  classes:any=[];
  arrclass1:any=[];
  defclass:any;
  defcorse:any;
  studentarr:any=[];
  studentarr1:any=[];
  modalOptions:NgbModalOptions;
   private modalRef: NgbModalRef;
   private modalRef1: NgbModalRef;
   selrole:any;
   emid:any;
rlid:any;  
  arrempfiltr: any=[];
  empstat:any="Active";
  objmnrts: any;

  constructor(private http: HttpClient,private mservice:MasterService,private lservice:AuthService, private fservice: FrontOffService, private hservice: HrmsService,private modalService: NgbModal,private router: ActivatedRoute) { }

  ngOnInit(): void {
    this.getmenuinfo(this.router.snapshot.url[0].path);
    this.rlid=localStorage.getItem('role');
    
  }
getmenuinfo(mid) {
     this.mservice.getmenuinfo(mid)
     .subscribe(
      resultArray =>
      { 
       console.log('menuinfo',resultArray);
       this.objmnrts=resultArray;
       this.studentclick();
      //  this.mascourse();
        //this._postsArray = resultArray;
       // this.formatmenudata(resultArray);
    // console.log('menus',JSON.stringify(resultArray));
     }
 ,
      error => console.log("Error :: " + error)
  )
 }
  staffclick()
  {
    
    this.getemployes();
    this.getrolesact();
    // this.getdesignation();
    // this.gethrmdept();
  }

  studentclick()
  {
    this.getstudents('s',0);
    this.masclass();
   
    this.mascourse();
    

  }
  gethrmdept() {
    this.mservice.get_hrmdept()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrdept = resultArray;
            this.arrdept1=resultArray;
this.arrdept1.unshift({depid:"0",depnm:"ALL"});
this.defdep="0";
           
        },
        error => console.log("Error :: " + error)
        )
  }

  resetpassword(emid) {

    if(confirm("Are you sure you wan't to reset password"))
    {
    this.hservice.resetpassword(emid)
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            alert(resultArray.message);
           
        },
        error => console.log("Error :: " + error)
        )
      }
  }

  changerole(emid,rlid) {

    if(confirm("Are you sure you wan't to change role"))
    {
    this.hservice.changerole(emid,rlid)
    .subscribe((result:any) => {

      alert (result.message);
      console.log('arrinst',result);
      
      if(result.status=='Success')
      {
      let localmodref=this.modalRef;
      localmodref.close();
      this.getemployes();
      // this.getmemberdetails('selstu','');
      //this.getrolesall();
      
      }
      else
      {
      
      }
      }, error => {
      
        alert ('error in saving');
      }
      );
      }
      
    }
  resetstupassword(emid,tag) {

    if(confirm("Are you sure you wan't to reset password"))
    {
    this.hservice.resetstupassword(emid,tag)
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            alert(resultArray.message);
           
        },
        error => console.log("Error :: " + error)
        )
      }
  }

  getdesignation() {
    this.mservice.sel_sp_hrmdesig()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrdesig = resultArray;

            this.arrdesig1=resultArray;
this.arrdesig1.unshift({desid:"0",desnm:"ALL"});
this.defdes="0";
           
        },
        error => console.log("Error :: " + error)
        )
  }


  openlinkmdl(content,obj) {
    this.selrole=obj.rlid;
    this.emid=obj.emid;


    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'sm'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }
   
  
  protected getrolesact() {
    this.lservice.getroles('selact')
        .subscribe(
        resultArray => {
            console.log('arrrolesall', resultArray);
            this.arrrolesall = resultArray;
           // this.defclass=resultArray[0].roid;
           // this.getroledet(resultArray[0].roid);
          //  this.objstfdata.clid=resultArray[0].desid;
            //this.objstfdata.defblgrp=resultArray[0].blgpnm;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  getemployes() {
    this.hservice.getemployes()
        .subscribe(
        resultArray => {
            console.log('getlibdepartment', resultArray);
            this.emparr = resultArray.emplst;
            this.emparr1 = resultArray.emplst;
            this.employeefilter('Active');
          var activeemps   = resultArray.emplst.filter(function(arr)
            {
        
              return arr.emstatus=='Active';
            });
            this.arremp= activeemps.map( o => { return { emid: o.emid, emnm: o.emnm} });
           // this.admdash=resultArray.empinfo;
            console.log('arremp',this.arremp);
            
        },
        error => console.log("Error :: " + error)
        )
  }


  employeefilter(tag)
  {
    this.arrempfiltr=this.emparr.filter(item => item.emstatus==tag);
  }

  getstudents(oprtype,stuid) {
    this.fservice.getstudents(oprtype,stuid)
        .subscribe(
        resultArray => {
            console.log('getlibdepartment', resultArray);
            this.studentarr = resultArray.stulst;
            this.studentarr1 = resultArray.stulst;
  
            //this.admdash=resultArray.studash;
            
        },
        error => console.log("Error :: " + error)
        )
  }


  onchangeemployee()
  {
    debugger
  if(this.defdep=="0" && this.defdes=="0" )
  {
  
    this.emparr=this.emparr1.filter(item => item.emstatus===this.defstat);
  }
  
  else if(this.defdep!="0" && this.defdes!="0" )
  {
  
    this.emparr=this.emparr1.filter(item => item.emstatus===this.defstat && item.depid===this.defdep && item.desid===this.defdes);
  }
  
  // else if(this.defclass!="0" && this.defcorse!="0" )
  // {
  
  //   this.studentarr=this.studentarr1.filter(item => item.stustatus===this.defstat && item.clid===this.defclass && item.crid===this.defcorse);
  // }
  
  else if(this.defdep!="0" && this.defdes==="0" )
  {
  
    this.emparr=this.emparr1.filter(item => item.emstatus===this.defstat && item.depid===this.defdep );
  }
  
  else if(this.defdep==="0" && this.defdes!="0" )
  {
  
    this.emparr=this.emparr1.filter(item => item.emstatus===this.defstat && item.desid===this.defdes );
  }
    //if()
  }

  exportstaff(){
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
     //var url=this.liservice.callurl+"export/expstudent.php?clcd="+clcd+"&aycd="+aycd+"&oprtype="+oprtype+"&clid="+this.defclass+"&crid="+this.defcorse;
     var url=this.hservice.callurl+"export/expstaff.php?clcd="+clcd+"&aycd="+aycd;
  
     window.open(url,'','');
   }

   exportrecord(tag){
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
     //var url=this.liservice.callurl+"export/expstudent.php?clcd="+clcd+"&aycd="+aycd+"&oprtype="+oprtype+"&clid="+this.defclass+"&crid="+this.defcorse;
     var url=this.fservice.callurl+"export/expstudent.php?clcd="+clcd+"&aycd="+aycd+"&alclnew="+tag;
  
     window.open(url,'','');
   }

  onchangefilters()
{
  debugger
if(this.defclass=="0" && this.defcorse=="0" )
{

  this.studentarr=this.studentarr1.filter(item => item.stustatus===this.defstat);
}

else if(this.defclass!="0" && this.defcorse!="0" )
{

  this.studentarr=this.studentarr1.filter(item => item.stustatus===this.defstat && item.clid===this.defclass && item.crid===this.defcorse);
}

// else if(this.defclass!="0" && this.defcorse!="0" )
// {

//   this.studentarr=this.studentarr1.filter(item => item.stustatus===this.defstat && item.clid===this.defclass && item.crid===this.defcorse);
// }

else if(this.defclass!="0" && this.defcorse==="0" )
{

  this.studentarr=this.studentarr1.filter(item => item.stustatus===this.defstat && item.clid===this.defclass );
}

else if(this.defclass==="0" && this.defcorse!="0" )
{

  this.studentarr=this.studentarr1.filter(item => item.stustatus===this.defstat && item.crid===this.defcorse );
}
  //if()
}

  masclass() {
    this.fservice.masclass()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.classes = resultArray;
            this.arrclass1=resultArray;
  this.arrclass1.unshift({clid:"0",clnm:"ALL"});
  this.defclass="0";
           
        },
        error => console.log("Error :: " + error)
        )
  }

  mascourse() {
    this.fservice.mascourse()
        .subscribe(
        resultArray => {
            console.log('arcourse', resultArray);
            this.arrcourse = resultArray;
            this.arrcourse1=resultArray;
    this.arrcourse1.unshift({crid:"0",crnm:"ALL"});
           this.defcorse="0";
        },
        error => console.log("Error :: " + error)
        )
  }
}
